import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'

import { MyTable } from './MyTable'

import { MyServerTableProps } from '../types/tableTypes'

export const MyServerTable =
  observer(
    <TColumnId extends string, TRow extends {id: React.Attributes['key']}>
    (props: MyServerTableProps<TColumnId, TRow>) => {
      useEffect(() => props.table.mount(), [props.table])

      return <MyTable {...props}/>
    })